/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React from "react";
import { useCompanyParameters } from "../../../utils/hooks";
import TableCell from "../../../components/TableCell";

export const INVENTORY_ON_HAND_COLUMNS = (Auth, isMechanicOnly) => {
  const { data: params } = useCompanyParameters();
  let columns = [
    {
      Header: "Item Number",
      id: "ItemNo",
      accessor: "ItemNo",
      sortType: (a, b) => {
        const aVal = a.original.ItemNo;
        const bVal = b.original.ItemNo;
        if (aVal > bVal) return 1;
        if (bVal > aVal) return -1;
        return 0;
      },
      Cell: ({ cell }) => (
        <TableCell.Link
          to={`/inventory/items/${cell.row.original.ItemRecIdRef}/details`}
          value={cell.row.original.ItemNo}
        />
      )
    },
    {
      Header: "Item Description",
      id: "ItemDescription",
      accessor: "ItemDescription"
    },
    {
      Header: "Item Category",
      id: "ItemCategoryDescription",
      accessor: "ItemCategoryDescription"
    },
    {
      Header: "Location",
      id: "LocationName",
      accessor: "LocationName"
    }
  ];
  if (params?.UsePrimaryStorageDimension) {
    columns = [
      ...columns,
      {
        Header: params?.PrimaryStorageDimension?.CodeDescription,
        id: "InvDim1Code",
        accessor: "InvDim1Code"
      }
    ];
  }
  if (params?.UseSecondaryStorageDimension) {
    columns = [
      ...columns,
      {
        Header: params?.SecondaryStorageDimension?.CodeDescription,
        id: "InvDim2Code",
        accessor: "InvDim2Code"
      }
    ];
  }
  if (params?.UseTertiaryStorageDimension) {
    columns = [
      ...columns,
      {
        Header: params?.TertiaryStorageDimension?.CodeDescription,
        id: "InvDim3Code",
        accessor: "InvDim3Code"
      }
    ];
  }
  columns = [
    ...columns,
    {
      Header: "Quantity OH",
      id: "QtyOnHand",
      accessor: "QtyOnHand",
      Cell: ({ cell }) => (
        <TableCell.Number value={JSON.stringify(cell.value)} />
      )
    }
  ];
  if (Auth && !isMechanicOnly) {
    if (params?.InventoryCostMethod?.CodeDescription.includes("Average")) {
      columns = [
        ...columns,
        {
          Header: "Cost",
          id: "ItemAvgCost",
          accessor: "ItemAvgCost",
          Cell: ({ cell }) => (
            <TableCell.Currency value={JSON.stringify(cell.value)} />
          )
        }
      ];
    }
    if (params?.InventoryCostMethod?.CodeDescription.includes("Standard")) {
      columns = [
        ...columns,
        {
          Header: "Cost",
          id: "ItemStdCost",
          accessor: "ItemStdCost",
          Cell: ({ cell }) => (
            <TableCell.Currency
              value={JSON.stringify(cell.value ? cell.value : 0)}
            />
          )
        }
      ];
    }
    columns = [
      ...columns,
      {
        Header: "Extension",
        id: "Extension",
        accessor: "Extension",
        Cell: ({ cell }) => (
          <TableCell.Currency
            value={JSON.stringify(cell.value ? cell.value : 0)}
          />
        )
      }
    ];
  }
  return [
    ...columns,
    {
      Header: "Active",
      accessor: "ItemActive",
      Cell: ({ cell }) => (cell.value ? "Yes" : "No")
    }
  ];
};
